import { HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiService } from "../../shared/services";
import { DialogService } from "../../shared/services/dialog.service";
import { Observable } from "rxjs";
import { JsReportAllDocumentsDto, JsReportDto, PayloadRequest } from "../models";

@Injectable({
  providedIn: 'root'
})
export class JsReportService {
    private apiService = inject(ApiService);
    private dialogService = inject(DialogService);


getAttestatoPreview(jsReportTemplateId: number): Observable<HttpResponse<Blob>> {
  const options = {
    headers: new HttpHeaders({
      'Accept': 'application/pdf'
    }),
    params: new HttpParams().set('format', 'pdf'),
    observe: 'response' as const,
    responseType: 'blob' as const,
  };

  return this.apiService.get(`js-report/${jsReportTemplateId}`, options);
}


  getJsReport(licenseId: number, documentType: string, downloadedByLearner?: boolean): Observable<HttpResponse<Blob>> {
    const options = {
    headers: new HttpHeaders({
      'Accept': 'application/pdf'
    }),
    params: new HttpParams().set('format', 'pdf'),
    observe: 'response' as const,
    responseType: 'blob' as const,
  };
  const jsReportDto: JsReportDto = { licenseId: licenseId, documentType: documentType, downloadedByLearner: downloadedByLearner};
    const payload: PayloadRequest<JsReportDto> = new PayloadRequest<JsReportDto>({ data: jsReportDto});
    return this.apiService.post(`js-report/get-report`, payload,  options);
  }

  getJsReportAllDocuments(licenseIds: number[]): Observable<HttpResponse<Blob>> {
    const options = {
    headers: new HttpHeaders({
      'Accept': 'application/zip'
    }),
    observe: 'response' as const,
    responseType: 'blob' as const,
  };
    const jsReportAllDocumentsDto: JsReportAllDocumentsDto = { licenseIds: licenseIds};
    const payload: PayloadRequest<JsReportAllDocumentsDto> = new PayloadRequest<JsReportAllDocumentsDto>({ data: jsReportAllDocumentsDto});
    return this.apiService.post(`js-report/get-all-report`, payload,  options);
  }

  async downloadPdfFromResponse(response: HttpResponse<Blob>): Promise<void> {
  let fileName = 'documento.pdf';

  // Un PDF valido inizia sempre con "%PDF-": se non è così il backend ha
  // risposto con un errore (JSON) che non deve essere salvato come documento.
  const isPdf = !!response.body && (await response.body.slice(0, 5).text()) === '%PDF-';
  if (!isPdf) {
    this.dialogService.openDialogError(
      'Errore',
      'Si è verificato un errore durante la generazione del documento. Riprova tra qualche istante.'
    );
    return;
  }

  const contentDisposition = response.headers.get('Content-Disposition');
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      fileName = match[1];
    }
  }

  const blob = new Blob([response.body!], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(url);
}
}